import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'

import { AddNewProgramFormModel } from '../AddNewProgram.types'

import { Flex, Typography, Button, Alert } from '@percent/lemonade'
import { AddNewProgramHeaderProps } from './AddNewProgramHeader.types'
import style from './AddNewProgramHeader.module.scss'

export function AddNewProgramHeader({ onSave, isSaving, isDuplicate }: AddNewProgramHeaderProps) {
  const { t } = useTranslation()

  const {
    formState: { errors }
  } = useFormContext<AddNewProgramFormModel>()

  const hasErrors = !!Object.keys(errors).length

  return (
    <Flex direction="column" gap={16}>
      {hasErrors && <Alert variant="info" title={t('errorMessage.fixAllFlags')} />}
      <Flex className={style.pageHeader} justify="space-between">
        <Typography variant="h2" className={style.pageTitle}>
          {isDuplicate ? t('typography.duplicateProgram') : t('typography.addNewProgram')}
        </Typography>
        <Button variant="secondary" size="small" onClick={onSave} disabled={hasErrors} loading={isSaving}>
          {t('button.save')}
        </Button>
      </Flex>
    </Flex>
  )
}
